import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn } from "@similarweb/ui-components";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

export const AiSectionContainer = styled(Stack)`
    padding: 16px 24px;
    border-bottom: 1px solid ${colorsPalettes.carbon[50]};
`;

export const AiSectionHeader = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
`;

export const AiSectionHeaderLabel = styled.span`
    ${setFontVariant("body2", colorsPalettes.carbon[400])};
    font-weight: 500;
`;

export const OptionalBadge = styled.span`
    ${setFontVariant("caption", colorsPalettes.carbon[200])};
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

export const AiSectionBody = styled(Stack)`
    gap: 12px;
    margin-top: 12px;
`;

export const DescriptionSubtitle = styled.div`
    ${setFontVariant("body2", colorsPalettes.carbon[300])};
`;

export const DescriptionTextArea = styled.textarea`
    ${setFontVariant("body2", colorsPalettes.carbon[500])};
    border: 1px solid ${colorsPalettes.carbon[100]};
    border-radius: 4px;
    padding: 10px 12px;
    resize: vertical;
    min-height: 64px;
    outline: none;
    transition: border-color 0.15s ease-in-out;

    &:focus {
        border-color: ${colorsPalettes.blue[400]};
    }

    &::placeholder {
        color: ${colorsPalettes.carbon[200]};
    }
`;

export const GenerateButtonRow = styled(Flex)`
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
`;

export const ErrorContainer = styled.div`
    ${setFontVariant("body2", colorsPalettes.red[400])};
    padding: 12px 16px;
    border: 1px solid ${colorsPalettes.red[100]};
    border-radius: 4px;
    background-color: ${colorsPalettes.red[100]};
`;

export const AiLoaderContainer = styled(Flex)`
    justify-content: center;
    align-items: center;
    padding: 40px 24px;
`;

export const LoaderWrapper = styled(FlexColumn)`
    justify-content: center;
    align-items: center;
`;

export const LoaderTextWrapper = styled(FlexColumn)`
    text-align: center;
`;

export const LoaderTitle = styled.p`
    margin: 0 0 16px;
    ${setFontVariant("h5_2", colorsPalettes.carbon[500])};

    @media (max-height: 800px) {
        margin-bottom: 4px;
        ${setFontVariant("h6", colorsPalettes.carbon[500])};
    }
`;

export const LoaderSubTitle = styled.p`
    margin: 0 0 16px;
    ${setFontVariant("body1", colorsPalettes.carbon[300])};

    @media (max-height: 800px) {
        margin-bottom: 4px;
        ${setFontVariant("body2", colorsPalettes.carbon[300])};
    }
`;

export const LoaderGif = styled.img`
    width: 200px;
    height: 200px;

    @media (max-height: 800px) {
        width: 170px;
        height: 170px;
    }
`;
